export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";